export default __webpack_public_path__ + "static/media/hr-solutions-header.17030051.svg";